import React from 'react';

import userDefaultImage from '../../../assets/svg/user-default-icon.svg';

import MentorAvailabilityStatusBeacon from '../MultiExpertWidget/mentorAvailabilityStatusBeacon';

import './widgetMentorInfoComponent.css';

const WidgetMentorInfoComponent = ({
  showMentorAvailabilityStatus = false,
  displayName,
  peerAvailability,
  profileImage,
  sessionTitle,
}) => {
  return (
    <div className="et-v2-widget-mentor-info-container">
      {showMentorAvailabilityStatus && (
        <MentorAvailabilityStatusBeacon availabilityStatus={peerAvailability} />
      )}
      <img
        className={
          profileImage ? 'et-v2-wmic-mentor-img' : 'et-v2-wmic-default-user-img'
        }
        src={profileImage ?? userDefaultImage}
        alt="image"
      />
      <div className="et-v2-wmic-mentor-name-title-wrap">
        <div className="et-v2-wmic-mentor-name">{displayName}</div>
        <div className="et-v2-wmic-title">{sessionTitle}</div>
      </div>
    </div>
  );
};

export default WidgetMentorInfoComponent;
